import { isArray } from 'lodash';

const TYPES = {
  KEY: 'key',
  LABEL: 'label',
};

export default {
  name: 'WRadioGroup',
  props: {
    extraClasses: {
      default: '',
      type: String,
    },
    name: {
      required: true,
      type: String,
    },
    options: {
      required: true,
      type: Array,
    },
    textAttribute: {
      default: TYPES.LABEL,
      type: String,
    },
    valueAttribute: {
      default: TYPES.KEY,
      type: String,
    },
    value: [Number, String, Array, Object, null],
  },
  data() {
    return {
      selected: null,
    };
  },
  watch: {
    selected(newVal) {
      this.$emit('input', newVal);
    },
  },
  computed: {
    formattedOptions() {
      if (this.isArrayItems) {
        return this.options?.map((option) => ({
          label: option,
          key: option,
        }));
      }
      return this.options;
    },
    isArrayItems() {
      return isArray(this.options?.[0] || {});
    },
    label() {
      return this.isArrayItems ? TYPES.LABEL : this.textAttribute;
    },
    key() {
      return this.isArrayItems ? TYPES.KEY : this.valueAttribute;
    },
  },
};
